import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { getBasePathWithoutTrailingSlash } from "./common/env.ts";
import { useRef } from "react";
import RootErrorBoundary from "./routes/root/RootErrorBoundary.tsx";
import { homeRoutes } from "./routes/home/homeRoutes.tsx";
import {
  rootLoader,
  rootRouteId,
  shouldRevalidateRoot,
} from "./routes/root/rootLoader.ts";
import Root from "./routes/root/Root.tsx";
import DeweyIntlProvider from "./common/core-ui/DeweyIntlProvider.tsx";
import { userRoutes } from "./routes/user/userRoutes.tsx";
import { HelmetProvider } from "react-helmet-async";
import FeaturesMain from "./routes/features/FeaturesMain.tsx";
import DotLoader from "./common/core-ui/DotLoader.tsx";
import styles from "./Main.module.scss";
import EmbedMain from "./routes/embed/EmbedMain.tsx";
import { rebuildHashedRoute } from "./routes/bookshelfLinks.ts";

function RootRedirect() {
  const location = useLocation();
  const destination =
    rebuildHashedRoute(location) ?? `/dashboard${location.search}`;
  return <Navigate to={destination} state={{ isRedirect: true }} />;
}

function createRouter() {
  return createBrowserRouter(
    [
      {
        errorElement: <RootErrorBoundary />,
        loader: rootLoader,
        id: rootRouteId,
        shouldRevalidate: shouldRevalidateRoot,
        element: <Root />,
        children: [
          homeRoutes,
          userRoutes,
          { path: "/embed/*?", element: <EmbedMain /> },
          { path: "/features", element: <FeaturesMain /> },
          {
            path: "/",
            element: <RootRedirect />,
          },
        ],
      },
    ],
    {
      basename: getBasePathWithoutTrailingSlash(),
      future: {
        v7_normalizeFormMethod: true,
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
      },
    }
  );
}

export default function Main() {
  const routerRef = useRef(createRouter());
  return (
    <HelmetProvider>
      <DeweyIntlProvider>
        <RouterProvider
          router={routerRef.current}
          fallbackElement={<DotLoader className={styles.loader} />}
        />
      </DeweyIntlProvider>
    </HelmetProvider>
  );
}
